import api from './api';

// PM analitik P6 — E11 Dönemler arası trendler. Uçlar backend PerformanceTrendsController'ın aynasıdır
// ([Route("v1/performance-trends")]). Süzgeç sözleşmesi PmAnalyticsFilter ile aynı; dönemler `periodIds` (2–8, virgüllü),
// `mode` (cohort | population), `sameRole` (true). api.js GET'te reject ETMEZ — hata sinyali res.data.status.
const BASE = '/v1/performance-trends';

export const getTrendSummary = (params) => api.get(`${BASE}/summary`, { params });
export const getTrendSeries = (params) => api.get(`${BASE}/series`, { params });
export const getTrendTransitions = (params) => api.get(`${BASE}/transitions`, { params });
export const getTrendUnits = (params) => api.get(`${BASE}/units`, { params });
export const getTrendEmployees = (params) => api.get(`${BASE}/employees`, { params });

// Ölçek eşleme onayı — yalnız İK (sunucu HrActorRules ile denetler).
export const getScaleOptions = () => api.get(`${BASE}/scale-options`);
export const getScaleMappings = () => api.get(`${BASE}/scale-mappings`);
export const approveScaleMapping = (payload) => api.post(`${BASE}/scale-mappings`, payload);
export const revokeScaleMapping = (id) => api.delete(`${BASE}/scale-mappings/${id}`);
